import { PermissionsEnum } from "@/auth/interfaces";
import { hasPermission, ROUTER_PATHS } from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import TableServicioDigital from "../../shared/TableServicioDigital";

export default function ServiciosDigitalesPage() {


  return (
    <SingleTableBoxScene
      title="Servicios Digitales"
      py={2}
      enableRedirect={hasPermission(PermissionsEnum.api_add_serviciodigital)}
      urlRedirect={ROUTER_PATHS.solucionesDigitales.servicios_crear_nav}
      visibleReport={true}
    >
        <TableServicioDigital/>

    </SingleTableBoxScene >
  );

}

